module.exports = __webpack_public_path__ + "images/hypothesis-test-12-13.webp";